'use client';
var classes = {"root":"m_f61ca620","input":"m_ccf8da4c","innerInput":"m_f2d85dd2","visibilityToggle":"m_b1072d44"};

export { classes as default };
//# sourceMappingURL=PasswordInput.module.css.mjs.map
